module.exports = __webpack_public_path__ + "static/favicon-0db809398bcc69ae14b3442b4f60b023.ico";